export default {
  title: {
    id: 'us_telco_comparators_plan_comparison_drawer_title',
    defaultMessage: 'Compare plans',
  },
  colVisible: {
    id: 'us_telco_comparators_plan_comparison_drawer_col_visible',
    defaultMessage: 'Visible Base',
  },
  colUsMobile: {
    id: 'us_telco_comparators_plan_comparison_drawer_col_us_mobile',
    defaultMessage: 'US Mobile Unlimited Starter',
  },
  colNoble: {
    id: 'us_telco_comparators_plan_comparison_drawer_col_noble',
    defaultMessage: 'Noble The No-Bull Plan',
  },
  rowMonthlyPrice: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_monthly_price',
    defaultMessage: 'Monthly price',
  },
  rowBackMarketExclusive: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_back_market_exclusive',
    defaultMessage: 'Back Market exclusive',
  },
  rowTaxesAndFees: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_taxes_and_fees',
    defaultMessage: 'Taxes & fees',
  },
  rowNetwork: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_network',
    defaultMessage: 'Network',
  },
  rowData: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_data',
    defaultMessage: 'Data',
  },
  rowHotspot: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_hotspot',
    defaultMessage: 'Hotspot',
  },
  rowVideoStreaming: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_video_streaming',
    defaultMessage: 'Video streaming',
  },
  rowTalkAndText: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_talk_and_text',
    defaultMessage: 'Talk & text',
  },
  rowInternationalTexting: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_international_texting',
    defaultMessage: 'International texting',
  },
  rowInternationalCalling: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_international_calling',
    defaultMessage: 'International calling',
  },
  rowInternationalData: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_international_data',
    defaultMessage: 'International data',
  },
  rowNoContract: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_no_contract',
    defaultMessage: 'No contract',
  },
  rowStandoutPerk: {
    id: 'us_telco_comparators_plan_comparison_drawer_row_standout_perk',
    defaultMessage: 'Standout perk',
  },
  visibleMonthlyPrice: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_monthly_price',
    defaultMessage: '$25/mo',
  },
  visibleBackMarketExclusive: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_back_market_exclusive',
    defaultMessage: '$5/mo off your mobile plan for 24 months',
  },
  visibleTaxesAndFees: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_taxes_and_fees',
    defaultMessage: 'Included',
  },
  visibleNetwork: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_network',
    defaultMessage: 'Verizon 5G & 4G LTE',
  },
  visibleData: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_data',
    defaultMessage: 'Unlimited',
  },
  visibleHotspot: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_hotspot',
    defaultMessage: 'Unlimited (5 Mbps)',
  },
  visibleVideoStreaming: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_video_streaming',
    defaultMessage: 'Up to 480p',
  },
  visibleTalkAndText: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_talk_and_text',
    defaultMessage: 'Unlimited',
  },
  visibleInternationalTexting: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_international_texting',
    defaultMessage: 'Mexico & Canada',
  },
  visibleInternationalCalling: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_international_calling',
    defaultMessage: 'Mexico & Canada',
  },
  visibleInternationalData: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_international_data',
    defaultMessage: 'Global Pass from $5/day',
  },
  visibleNoContract: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_no_contract',
    defaultMessage: '✓',
  },
  visibleStandoutPerk: {
    id: 'us_telco_comparators_plan_comparison_drawer_visible_standout_perk',
    defaultMessage:
      'Job loss protection — Visible covers your bill up to 3 months if you lose your job',
  },
  usMobileMonthlyPrice: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_monthly_price',
    defaultMessage: '$25/mo (or ~$17/mo with an annual plan purchase)',
  },
  usMobileBackMarketExclusive: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_back_market_exclusive',
    defaultMessage: '$100 off your Back Market phone with any plan purchase',
  },
  usMobileTaxesAndFees: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_taxes_and_fees',
    defaultMessage: 'Included',
  },
  usMobileNetwork: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_network',
    defaultMessage: 'Your choice: AT&T, T-Mobile, or Verizon',
  },
  usMobileData: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_data',
    defaultMessage: 'Unlimited',
  },
  usMobileHotspot: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_hotspot',
    defaultMessage: '20 GB',
  },
  usMobileVideoStreaming: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_video_streaming',
    defaultMessage: 'Up to 4K',
  },
  usMobileTalkAndText: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_talk_and_text',
    defaultMessage: 'Unlimited',
  },
  usMobileInternationalTexting: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_international_texting',
    defaultMessage: '200+ countries',
  },
  usMobileInternationalCalling: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_international_calling',
    defaultMessage: 'Add-on from $3/mo',
  },
  usMobileInternationalData: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_international_data',
    defaultMessage: '1 GB included',
  },
  usMobileNoContract: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_no_contract',
    defaultMessage: '✓',
  },
  usMobileStandoutPerk: {
    id: 'us_telco_comparators_plan_comparison_drawer_us_mobile_standout_perk',
    defaultMessage: 'Switch networks freely anytime — no carrier lock-in',
  },
  nobleMonthlyPrice: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_monthly_price',
    defaultMessage: '$50/mo',
  },
  nobleBackMarketExclusive: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_back_market_exclusive',
    defaultMessage:
      '$150 off your Back Market phone with a 6-month plan purchase',
  },
  nobleTaxesAndFees: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_taxes_and_fees',
    defaultMessage: 'Not included (+tax)',
  },
  nobleNetwork: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_network',
    defaultMessage: 'T-Mobile 5G',
  },
  nobleData: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_data',
    defaultMessage: 'Unlimited',
  },
  nobleHotspot: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_hotspot',
    defaultMessage: 'Not included',
  },
  nobleVideoStreaming: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_video_streaming',
    defaultMessage: '—',
  },
  nobleTalkAndText: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_talk_and_text',
    defaultMessage: 'Unlimited',
  },
  nobleInternationalTexting: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_international_texting',
    defaultMessage: 'Worldwide',
  },
  nobleInternationalCalling: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_international_calling',
    defaultMessage: '80+ countries included',
  },
  nobleInternationalData: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_international_data',
    defaultMessage: 'Mexico & Canada free; $5/day in 180+ countries',
  },
  nobleNoContract: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_no_contract',
    defaultMessage: '✓',
  },
  nobleStandoutPerk: {
    id: 'us_telco_comparators_plan_comparison_drawer_noble_standout_perk',
    defaultMessage: 'Earn up to $20/mo cash back for unused data',
  },
}
